var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccesoListaVenta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 259.95 251.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8e1e32;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 33") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rlfrPg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2,120.66c1-.54,2-1.53,3-1.52,1.52,0,3.42.31,4.4,1.27.78.76.69,2.72.5,4.09-.51,3.82-2,7.65-1.81,11.4,3.86,59.86,51.57,108.4,111.32,111.94,47.71,2.83,84.9-16.8,111.31-56.64,1.07-1.61.87-4,1.66-5.87.69-1.63,1.64-3.7,3-4.3,1-.42,4.11,1.28,4.12,2.06,0,1.76-1.06,3.7-2.13,5.27s-3,2.51-4,4.08C195,253.72,114.08,270.13,55.76,227.66c-32.21-23.47-48.86-56-50.68-95.94-.13-2.78.46-5.83-3.13-7.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.67,21.25A103,103,0,0,1,233.09,125.16c-.28,56.89-46.78,102.75-104,102.5C72.56,227.41,26.59,180.49,27,123.35,27.31,66.71,73.8,21,130.67,21.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.26,147.84a9.22,9.22,0,0,1,9.15,9.24,9.08,9.08,0,0,1-18.15.1A9.19,9.19,0,0,1,249.26,147.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.9,93.6a8.91,8.91,0,0,1-8.7,9,8.83,8.83,0,0,1-9.2-9,8.57,8.57,0,0,1,8.63-8.94A8.85,8.85,0,0,1,20.9,93.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,122.62a7,7,0,0,1-6.78,7,6.88,6.88,0,0,1-7.17-7,6.68,6.68,0,0,1,6.72-7A6.9,6.9,0,0,1,14,122.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31,66.62a7,7,0,0,1-6.78,7,6.88,6.88,0,0,1-7.17-7,6.68,6.68,0,0,1,6.72-7A6.9,6.9,0,0,1,31,66.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244,185.62a7,7,0,0,1-6.78,7,6.88,6.88,0,0,1-7.17-7,6.68,6.68,0,0,1,6.72-7A6.9,6.9,0,0,1,244,185.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260,124.62a7,7,0,0,1-6.78,7,6.88,6.88,0,0,1-7.17-7,6.68,6.68,0,0,1,6.72-7A6.9,6.9,0,0,1,260,124.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.17,67.23c.63,1,1.06,2.28,1.94,2.75,1.33.71,3.14,1.35,4.44,1,1-.29,1.87-2,2.34-3.27,1.34-3.53,1.78-7.55,3.73-10.65C61.92,7.51,126.29-11.5,180.2,13.86c43.05,20.24,66.42,54.76,70.94,101.51.18,1.89-1.11,3.85-1.29,5.82-.16,1.73-.29,4,.65,5.14.66.82,4.18.85,4.56.19.84-1.5.8-3.68.6-5.53s-1.44-3.58-1.57-5.39C249.06,44.73,186-7.8,115.14,1,76,5.79,46.29,25.81,26.07,59.22c-1.41,2.33-2.32,5.23-6,4.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cqGdGx.tif"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.27,158.66H124.66c-.83-.16-1.65-.37-2.48-.48-18.46-2.29-33.12-11.1-44.2-25.94-2.32-3.11-2.35-2.08,0-5.19,15.52-20.28,36.13-28.82,61.36-25.7,16.82,2.08,30.4,10.35,41.1,23.41,1.23,1.5,2.32,3.09,3.48,4.64v.52a6.47,6.47,0,0,0-.5.56c-10.68,15.31-25.15,24.6-43.65,27.47Zm11.39-29A16.57,16.57,0,1,0,130,146.23,16.58,16.58,0,0,0,146.66,129.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.52,129.64a12.43,12.43,0,1,1-12.31-12.41A12.45,12.45,0,0,1,142.52,129.64Zm-8.29,0a4.14,4.14,0,1,0-4.07,4.18A4.17,4.17,0,0,0,134.23,129.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rlfrPg-2",
    "data-name": "rlfrPg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.84,32.46c.38.74,1.08,1.48,1.06,2.2a4.91,4.91,0,0,1-1,3.15c-.56.55-2,.47-2.95.32-2.75-.41-5.5-1.57-8.19-1.44-43.16,2.12-78.66,35.94-81.87,78.94C40.37,150,54.09,177,82.49,196.43c1.15.79,2.87.67,4.21,1.26,1.16.51,2.64,1.22,3.06,2.23.29.71-1,3-1.53,3a7.24,7.24,0,0,1-3.77-1.59c-1.1-.78-1.77-2.18-2.89-2.9C37.86,170,26.93,111.57,58.17,70c17.26-22.94,40.88-34.56,69.66-35.44,2-.06,4.2.4,5.13-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.1,208.83a6.64,6.64,0,0,1-6.76,6.48,6.54,6.54,0,0,1,.13-13.07A6.63,6.63,0,0,1,112.1,208.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.66,47.83a6.45,6.45,0,1,1,.17-12.89,6.18,6.18,0,0,1,6.35,6.31A6.39,6.39,0,0,1,153.66,47.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.27,42.52a5,5,0,1,1,.13-10,4.8,4.8,0,0,1,4.94,4.91A5,5,0,0,1,134.27,42.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.44,54a5,5,0,0,1-5-5,5,5,0,0,1,5.11-5.09,4.82,4.82,0,0,1,4.95,4.92A5,5,0,0,1,174.44,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.36,206a5,5,0,1,1,.13-10,4.82,4.82,0,0,1,5,4.91A5,5,0,0,1,86.36,206Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.12,218.25a5,5,0,0,1-5-5,5,5,0,0,1,5.12-5.09,4.81,4.81,0,0,1,4.94,4.91A5,5,0,0,1,130.12,218.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.14,44.74c-.69.44-1.65.73-2,1.36a5,5,0,0,0-.77,3.19c.19.75,1.43,1.37,2.33,1.73,2.52,1,5.42,1.36,7.63,2.8,35.34,23.09,48.31,69.66,29.45,108.21-15.06,30.79-40.18,47.24-73.9,50-1.36.11-2.76-.84-4.18-1-1.24-.13-2.85-.25-3.7.41-.61.46-.67,3-.19,3.28a7,7,0,0,0,4,.5c1.31-.13,2.58-1,3.89-1.07,51.1-2.84,89.64-47.7,84.12-98.81-3.05-28.23-17.14-49.87-41-64.8-1.66-1.05-3.74-1.73-3.23-4.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccesoListaVenta);
export default __webpack_public_path__ + "static/media/acceso-lista-venta.0951e675a954221050f2d39f1c2a47ca.svg";
export { ForwardRef as ReactComponent };